/// <reference path="../../../typings/index.d.ts" />
/// <reference path="../apimodel.d.ts" />
/// <reference path="dialogoutcome.ts" />

module App.Common {

	export class PicklistConfig<T> implements IConvertibleToModalDialogConfig {

		public title: string;

		public selectedItem: T;

		public size = BootstrapSize.Medium;

		public controller: string;

		public templateUrl: string;

		public onClose: <TResult>(result: TResult) => void;

		public onClosing: <TResult>(result: TResult) => angular.IPromise<any>;

		public onDismiss: <TResult>(result: TResult) => void;

		public onDismissing: <TResult>(result: TResult) => angular.IPromise<any>;

		public toModalDialogConfig() {
			var config = new ModalDialogConfig();
			config.title = this.title;
			config.templateUrl = this.templateUrl || 'Templates/Common/PicklistView.html';
			config.controller = this.controller;
			config.size = this.size;
			config.canDismissWithBackdropClick = false;
			config.canDismissWithEscapeKey = true;
			config.onClose = this.onClose;
			config.onClosing = this.onClosing;
			config.onDismiss = this.onDismiss;
			config.onDismissing = this.onDismissing;
			return config;
		}

	}

}